import { Link } from "react-router";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "../../public/IMG_1579.JPG";

export function Home() {
  return (
    <section className="mx-auto flex max-w-7xl flex-col gap-32 px-6 py-20">
      <div className="grid gap-16 lg:grid-cols-[1.1fr_0.9fr] items-center min-h-[70vh]">
        <div className="space-y-10">
          <div className="space-y-6">
            <h1 className="font-serif text-5xl font-light leading-tight tracking-tight text-foreground sm:text-7xl">
              Elevated sweets for{" "}
              <span className="italic text-primary">moments</span> that deserve
              artistry.
            </h1>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">
              Small-batch baked goods made with love. From classic cookies to
              custom cakes, Miss T's brings homemade quality to every occasion.
            </p>
          </div>

          <div className="flex flex-wrap gap-4">
            <Button
              className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 text-base"
              asChild
            >
              <Link to="/plan-pickup">
                Plan a Pickup
                <ArrowRight className="size-4 ml-2" />
              </Link>
            </Button>
            <Button
              variant="outline"
              className="border-primary/30 text-primary hover:bg-primary/10 h-12 px-8 text-base bg-transparent"
              asChild
            >
              <Link to="/menu">View Menu</Link>
            </Button>
          </div>
        </div>

        <div className="relative flex justify-center">
          <div className="relative w-full max-w-md aspect-square rounded-full overflow-hidden border-2 border-primary/20 shadow-2xl">
            <img
              src={logo}
              alt="Miss T's Home Bakery"
              className="size-full object-cover"
            />
          </div>
          <div className="absolute -top-8 -right-8 w-48 h-48 border border-primary/20 rounded-full opacity-40" />
          <div className="absolute -bottom-4 -left-4 w-24 h-24 border border-primary/10 rounded-full opacity-40" />
        </div>
      </div>
    </section>
  );
}
